/**
 * lookupCache — tiny in-memory cache for LOW-CHURN "lookup" collections that many
 * forms / the page shell read on mount purely for DISPLAY: region + area names
 * (CustomerSelect badges, POS Sales filters) and the POS counter menu
 * (PageLayout). These used to be a fresh getDocs on EVERY form / page mount.
 *
 * Backed by fyDataCache (default 30-min TTL, per browser session) and tagged for
 * the Super Admin Reads tab. Staleness is acceptable here — a renamed region or a
 * newly-added counter shows after the TTL or a reload. Do NOT use this for
 * balances or stock (those have their own freshness rules).
 */

import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { getCached } from './fyDataCache';
import { recordReads } from './readTelemetry';

const loadColl = async (companyId, coll, tag) => {
  const snap = await getDocs(collection(db, 'companies', companyId, coll));
  recordReads(companyId, snap.size, tag);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const getRegionsCached = (companyId) =>
  getCached(`lookup|regions|${companyId}`, () => loadColl(companyId, 'regions', 'lookup-regions'));

export const getAreasCached = (companyId) =>
  getCached(`lookup|areas|${companyId}`, () => loadColl(companyId, 'areas', 'lookup-areas'));

// Counters can change during POS setup, so a shorter TTL keeps the sidebar menu
// reasonably fresh without re-reading on every navigation.
const COUNTERS_TTL_MS = 10 * 60 * 1000;
export const getPosCountersCached = (companyId) =>
  getCached(`lookup|posCounters|${companyId}`, () => loadColl(companyId, 'posCounters', 'lookup-posCounters'), COUNTERS_TTL_MS);

